import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    isSSR: false,
    data: [],
    error: null,
    isLoading: true
};

export const fetchDataSuccess = (state = INITIAL_STATE, { data }) => {
    return { ...state, data, error: null, isLoading: false };
};

export const fetchDataFailure = (state = INITIAL_STATE, { error }) => {
    return { ...state, error, data: [], isLoading: false };
};

export const HANDLERS = {
    [Types.FETCH_EXPERTS_DATA_SUCCESS]: fetchDataSuccess,
    [Types.FETCH_EXPERTS_DATA_FAILURE]: fetchDataFailure
};

export default createReducer(INITIAL_STATE, HANDLERS);
